
import DownloadButton from "../../downloadButton/downloadButton";
import ImgBox from "../../imageGallery/imgBox";
import LoadingSpinner from "../../spinner/loadingSpinner";
import { MdReportGmailerrorred } from "react-icons/md";
function ImageDataTable({ fileDetails }) {
    console.log(fileDetails,"fileDetails")
    return (
        <>
            {fileDetails?.length > 0 &&
                fileDetails.map((item, i) => (
                    <tr key={i} className="bg-white border-b   hover:bg-gray-50 ">
                        <td className="px-6 py-4">
                            <span >
                                {parseInt(i) + 1}
                            </span>
                        </td>
                        <td className="px-6 py-4">
                            <ImgBox imageUrl={item?.url} wapperCss={"w-16 h-16"} imageCss={"rounded-md w-16 h-16 object-cover"} />
                        </td>
                        <td className="px-6 py-4">
                            <span >
                                {item?.value ? item?.value : item?.urlStatus}
                            </span>
                        </td>
                        <td className="px-6 py-4">
                            {<span>{item?.uploadStatus ? item?.uploadStatus : ""}</span>}
                        </td>
                        <td className="px-6 py-4">
                            {<span>{item?.sku_id ? item?.sku_id : ""}</span>}
                        </td>
                        <td className="px-6 py-4">
                            {item?.output_url ?
                                <ImgBox imageUrl={item?.output_url} wapperCss={"w-16 h-16"} imageCss={"rounded-md w-16 h-16 object-cover"} />
                                : (item?.uploadStatus === "processing_failed" ?
                                    <span className="flex"> <MdReportGmailerrorred className="mr-2 text-red-500" />{item?.uploadStatus}</span> :
                                    ((item?.uploadStatus === 'processing' || item?.uploadStatus === 'accepted') ? <LoadingSpinner /> : ""))}
                        </td>
                        <td className="px-6 py-4 text-right" key={i}>
                            <DownloadButton item={item} />
                        </td>
                    </tr>
                ))}
        </>
    )
}

export default ImageDataTable